<section class="eco-hist">
  <!-- Caminho padrão do Cognito (app-breadcrumb), como no Societário; o canto direito fica livre para o avatar. -->
  <header class="eco-hist__top-bar">
    <app-breadcrumb class="eco-hist__crumbs" [home]="breadcrumbHome()" [items]="breadcrumbs" />
  </header>

  <!-- Segunda linha: o que é a tela à esquerda, filtros à direita. -->
  <div class="eco-hist__sub-bar">
    <div class="eco-hist__summary">
      <h1 class="eco-hist__title">Histórico da economia</h1>
      <p class="eco-hist__subtitle">
        @if (companiesLabel()) {
          {{ companiesLabel() }} ·
        }
        por que a economia mudou entre duas datas
      </p>
    </div>
    <app-economy-history-filters
      class="eco-hist__actions"
      [measure]="measure()"
      [loading]="loading()"
      (periodChange)="onPeriodChange($event)"
      (measureChange)="setMeasure($event)"
      (refresh)="load()"></app-economy-history-filters>
  </div>

  @if (!companyIds().length) {
    <div class="eco-hist__empty">
      Abra esta tela pelo botão "Histórico e o que mudou" na lista de operações do cenário de
      economia, com as empresas selecionadas no dashboard.
    </div>
  } @else if (loading() && !data()) {
    <div class="eco-hist__loading">
      <app-cog-loading-spinner [size]="48"></app-cog-loading-spinner>
      <p>Carregando o histórico…</p>
    </div>
  } @else if (error()) {
    <div class="eco-hist__empty eco-hist__empty--error">
      Não foi possível carregar o histórico. Tente atualizar.
    </div>
  } @else if (data() && !hasHistory()) {
    <div class="eco-hist__empty">
      Ainda não há versões gravadas para estas empresas no período. O histórico começa a ser gravado
      na primeira geração da economia depois da publicação desta tela.
    </div>
  } @else if (activeMeasure(); as m) {
    @if (data()!.startedAtFirstVersion) {
      <p class="eco-hist__notice">
        <i class="pi pi-info-circle" aria-hidden="true"></i>
        Sem versão gravada até a data inicial: o período começa na primeira versão do histórico ({{
          data()!.startDate | vaultDate
        }}).
      </p>
    }

    <div class="eco-hist__body" [class.is-loading]="loading()">
      <app-economy-changes-breakdown
        [measure]="m"
        [measureKey]="measure()"
        [timeline]="data()!.timeline"
        [companyNames]="data()!.companyNames"
        [startDate]="data()!.startDate"
        [endDate]="data()!.endDate"
        (loanSelected)="openLoan($event)"></app-economy-changes-breakdown>

      <app-economy-history-timeline
        [entries]="data()!.timeline"
        [measure]="measure()"
        [companyNames]="data()!.companyNames"
        [showCompany]="companyIds().length > 1"></app-economy-history-timeline>
    </div>
  }
</section>

<app-modal-loan-details #loanDetailsModal></app-modal-loan-details>
